import React from "react";
import PropTypes from "prop-types";

import { Wrapper } from "./styles";

const ToggleSwitch = ({ id, name, checked, onChange, disabled }) => {
  function handleKeyPress(e) {
    if (e.keyCode !== 32) return;

    e.preventDefault();
    onChange(!checked);
  }

  return (
    <Wrapper disabled={disabled}>
      <input
        type="checkbox"
        name={name}
        id={name}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      {name ? (
        <label
          tabIndex={disabled ? -1 : 1}
          onKeyDown={(e) => handleKeyPress(e)}
          htmlFor={name}
        >
          <span tabIndex={-1} />
          <span tabIndex={-1} />
        </label>
      ) : null}
    </Wrapper>
  );
};

// Set optionLabels for rendering.
ToggleSwitch.defaultProps = {
  disabled: false,
};

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  optionLabels: PropTypes.array,
  small: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ToggleSwitch;
